import * as React from "react"
import { type DigitsLocation } from "@digits-shared/components/Router/DigitsLocation"

interface PageSlideContextProps {
  location: DigitsLocation
  previousLocation?: DigitsLocation
}

export const PageSlideContext = React.createContext<PageSlideContextProps | undefined>(undefined)

export function usePageSlideContext() {
  const context = React.useContext(PageSlideContext)
  if (!context) {
    throw new Error("No PageSlideContext.Provider found when calling usePageSlideContext.")
  }
  return context
}
